import api from '@/api/personal'

const state = {
  videoNavigationIsExpend: true
}

const actions = {
  getPersonalInfo (context, params) {
    return api.getPersonalInfo(params)
  },
  getMyRewards (context, params) {
    return api.getMyRewards(params)
  },
  getMyReferralHistory (context, params) {
    return api.getMyReferralHistory(params)
  },
  getMyRedeemHistory (context, params) {
    return api.getMyRedeemHistory(params)
  },
  getRedeemPointsResult (context, params) {
    return api.getRedeemPointsResult(params)
  },
  redeemPoints (context, redeemInfo) {
    return api.redeemPoints(redeemInfo)
  },
  activePersonalEmployee (context) {
    return api.activePersonalEmployee()
  },
  getMyPotentialCandidate (context, params) {
    return api.getMyPotentialCandidate(params)
  },
  updateMyPotentialCandidateAttitude (context, updateInfo) {
    return api.updateMyPotentialCandidateAttitude(updateInfo)
  },
  getMyHiddenPotentialCandidate (context, params) {
    return api.getMyHiddenPotentialCandidate(params)
  },
  getMyAppliedPotentialCandidate (context, params) {
    return api.getMyAppliedPotentialCandidate(params)
  },
  getMyDashboardData (context, params) {
    return api.getMyDashboardData(params)
  },
  getMyLeaderBoardData (context, params) {
    return api.getMyLeaderBoardData(params)
  },
  isResumeFinished (context, params) {
    return api.isResumeFinished(params)
  },
  getResumeData (context, params) {
    return api.getResumeData(params)
  },
  createOrUpdateResumeData (context, data) {
    return api.createOrUpdateResumeData(data.resumeData, data.jobId, data.companyId)
  },
  getMiniResumeData (context, params) {
    return api.getMiniResumeData(params)
  },
  createOrUpdateMiniResumeData (context, data) {
    return api.createOrUpdateMiniResumeData(data.resumeData, data.jobId, data.companyId)
  },
  getBasicResumeData (context, params) {
    return api.getBasicResumeData(params)
  },
  createOrUpdateBasicResumeData (context, data) {
    return api.createOrUpdateBasicResumeData(data.resumeData, data.jobId, data.companyId)
  },
  uploadCandidatePhoto (context, { photo, jobId, companyId }) {
    return api.uploadCandidatePhoto(photo, jobId, companyId)
  },
  checkEmailAndPhone (context, params) {
    return api.checkEmailAndPhone(params)
  },
  getResumeFromThirdParty (context, params) {
    return api.getResumeFromThirdParty(params)
  },
  checkLoginStatusForThirdParty (context, params) {
    return api.checkLoginStatusForThirdParty(params)
  },
  uploadResumeFromThirdparty (context, data) {
    return api.uploadResumeFromThirdparty(data)
  },
  parseResumeFromThirdParty (context, params) {
    return api.parseResumeFromThirdParty(params)
  },
  getUrlToImportThirdPartyResume (context, params) {
    return api.getUrlToImportThirdPartyResume(params)
  },
  submitResumeToReferral (context, params) {
    return api.submitResumeToReferral(params)
  },
  getForgetPasswordUrlForThirdPartyLogin (context, params) {
    return api.getForgetPasswordUrlForThirdPartyLogin(params)
  },
  getAgreementStatus (context, params) {
    return api.getAgreementStatus(params)
  },
  updateAgreement (context, agreementInfo) {
    return api.updateAgreement(agreementInfo)
  },
  getConsentAgreementStatus (context, params) {
    return api.getConsentAgreementStatus(params)
  },
  updateConsentAgreementStatus (context, agreementInfo) {
    return api.updateConsentAgreementStatus(agreementInfo)
  },
  personalUploadResume (context, fileInfo) {
    return api.personalUploadResume(fileInfo)
  },
  parseCandidateResumeByCandidate (context, fileInfo) {
    return api.parseCandidateResumeByCandidate(fileInfo)
  },
  getResumeApplySuccessInfo (context, { jobId, params }) {
    return api.getResumeApplySuccessInfo(jobId, params)
  },
  getPersonalApplication (context, params) {
    return api.getPersonalApplication(params)
  },
  getPersonalProfileInfo (context, params) {
    return api.getPersonalProfileInfo(params)
  },
  updatePersonalCandidateAvatar (context, { jobId, data }) {
    return api.updatePersonalCandidateAvatar(jobId, data)
  },
  getPersonalReportInfo (context, params) {
    return api.getPersonalReportInfo(params)
  },
  personalRevokeApplication (context, { jobId, data }) {
    return api.personalRevokeApplication(jobId, data)
  },
  personalRevokeAllApplication (context, data) {
    return api.personalRevokeAllApplication(data)
  },
  exportPersonalProfilePDF (context, data) {
    return api.exportPersonalProfilePDF(data)
  },
  getExportPersonalProfilePDFTaskStatus (context, params) {
    return api.getExportPersonalProfilePDFTaskStatus(params)
  },
  updatePersonalResumeMobile (context, data) {
    return api.updatePersonalResumeMobile(data)
  },
  setVideoNavigationIsExpend ({ commit }, videoNavigationIsExpend) {
    commit('SET_VIDEO_NAVIGATION_IS_EXPEND', videoNavigationIsExpend)
  },
  getPersonalAllOfferLetter (context, params) {
    return api.getPersonalAllOfferLetter(params)
  },
  getPersonalOfferLetterDetailById (context, inviteId) {
    return api.getPersonalOfferLetterDetailById(inviteId)
  },
  getJobQuestion (context, { jobId, params }) {
    return api.getJobQuestion(jobId, params)
  },
  saveJobQuestion (context, { jobId, data }) {
    return api.saveJobQuestion(jobId, data)
  },
  getJobInviteQuestion (context, { jobId, params }) {
    return api.getJobInviteQuestion(jobId, params)
  },
  saveJobInviteQuestion (context, { jobId, data }) {
    return api.saveJobInviteQuestion(jobId, data)
  },
  getJobQuestionVideoPaly (context, params) {
    return api.getJobQuestionVideoPaly(params)
  },
  updateJobQuestionVideo (context, data) {
    return api.updateJobQuestionVideo(data)
  },
  dispatchApply (context, { jobId, params }) {
    return api.dispatchApply(jobId, params)
  },
  updatePassword (context, data) {
    return api.updatePassword(data)
  },
  createParseResumeInfoByCandidateTask (context, data) {
    return api.createParseResumeInfoByCandidateTask(data)
  },
  getParseResumeInfoByCandidateTaskStatus (context, params) {
    return api.getParseResumeInfoByCandidateTaskStatus(params)
  }
}

const mutations = {
  SET_VIDEO_NAVIGATION_IS_EXPEND (state, videoNavigationIsExpend) {
    state.videoNavigationIsExpend = videoNavigationIsExpend
  }
}

const getters = {
  isExpend: (state) => {
    return state.videoNavigationIsExpend
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
